import { Controller } from "stimulus";

export default class extends Controller
{
    handleEdit(event)
    {
        if (event.detail[0].success)
        {
            const editEvent = new CustomEvent("show-toast", { detail: "Site address successfully updated!" });
            window.dispatchEvent(editEvent);
        }
        else
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: \n" + event.detail[0].error })
            window.dispatchEvent(errorEvent);
        }
    }
}